import { FileWithPath } from 'file-selector';
import api from '.';

export interface ProjectDocumentRevisionFile {
  file: FileWithPath;
  isPublic: boolean;
}

export async function getProjectDocumentRevisionFile(
  projectDocumentRevisionFileId: number
) {
  const { data } = await api.get(
    `/project-document-revision-files/${projectDocumentRevisionFileId}`
  );
  return data;
}

export async function createProjectDocumentRevisionFiles({
  projectDocumentRevisionFiles,
  projectDocumentRevisionId
}: {
  projectDocumentRevisionFiles: ProjectDocumentRevisionFile[];
  projectDocumentRevisionId: number;
}) {
  const formData = new FormData();
  formData.append(
    'projectDocumentRevisionId',
    projectDocumentRevisionId.toString()
  );
  projectDocumentRevisionFiles.forEach(({ file, isPublic }) => {
    formData.append('files', file);
    formData.append('isPublics', isPublic.toString());
  });

  const { data } = await api.post(
    '/project-document-revision-files',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}

export async function reUploadProjectDocumentRevisionFile({
  projectDocumentRevisionFile,
  projectDocumentRevisionFileId
}: {
  projectDocumentRevisionFile: ProjectDocumentRevisionFile;
  projectDocumentRevisionFileId: number;
}) {
  const { file } = projectDocumentRevisionFile;
  const formData = new FormData();
  formData.append(
    'projectDocumentRevisionFileId',
    projectDocumentRevisionFileId.toString()
  );
  formData.append('file', file);

  const { data } = await api.put(
    `/project-document-revision-files/${projectDocumentRevisionFileId}/re-upload`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}

export async function updateProjectDocumentRevisionFile({
  isPublic,
  projectDocumentRevisionFileId
}: {
  isPublic: boolean;
  projectDocumentRevisionFileId: number;
}) {
  const updateFile = {
    isPublic
  };
  const { data } = await api.put(
    `/project-document-revision-files/${projectDocumentRevisionFileId}`,
    updateFile
  );
  return data;
}

export function deleteProjectDocumentRevisionFile(
  projectDocumentRevisionFileId: number
) {
  return api.delete(
    `/project-document-revision-files/${projectDocumentRevisionFileId}`
  );
}
